// src/App.tsx
import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import PrivateRoute from "./components/PrivateRoute";
import HomePage from "./pages/HomePage"; // Keep HomePage for now if you still want it accessible, otherwise remove it
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import TasksPage from "./pages/TaskPage"; // Corrected from TaskPage to TasksPage
import AuthService from "./services/auth.service";
import { User } from "./types/auth";

const App: React.FC = () => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    setCurrentUser(user);

    // Redirect logic for the root path
    if (window.location.pathname === "/") {
      // Only apply this logic for the root path
      if (user) {
        navigate("/tasks", { replace: true }); // Redirect to tasks if logged in
      } else {
        navigate("/login", { replace: true }); // Redirect to login if not logged in
      }
    }
  }, [navigate]); // Depend on navigate to ensure it's stable

  const logOut = () => {
    AuthService.logout();
    setCurrentUser(null);
    navigate("/login"); // Redirect to login after logout
  };

  return (
    <div className="App">
      <Navbar currentUser={currentUser} logOut={logOut} />
      <div className="container mt-3">
        <Routes>
          {/* The root route will now conditionally redirect based on login status */}
          <Route path="/" element={<TasksPage />} />{" "}
          {/* Keep HomePage or remove if you want a blank root */}
          <Route
            path="/login"
            element={<LoginPage setCurrentUser={setCurrentUser} />}
          />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/tasks"
            element={
              <PrivateRoute>
                <TasksPage />
              </PrivateRoute>
            }
          />
          {/* Add more routes as needed (e.g., /profile, /admin) */}
          <Route path="*" element={<h1>404 - Page Not Found</h1>} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
